import React, { useEffect, useState } from "react";
import Section from "../../Components/Section/Section";
import {
  Button,
  Col,
  Container,
  Image,
  Row,
  Form,
  Spinner,
} from "react-bootstrap";
import DefaultProduct from "../../assets/images/default-product.png";

import Heading from "../../Components/Heading/Heading";
import { getStyles } from "./ConfirmOrder.style";
import { FaArrowRight } from "react-icons/fa";
import ProductImage from "../../assets/images/aata.png";
import { useLocation, useNavigate } from "react-router-dom";
import { COD_Payment, Payment_Status, View_Cart, Estimate_Cost } from "../../Api";
import { base_url } from "../../Api/ApiConst";
import { toast } from "react-toastify";
import { CLEAR_CART } from "../../Redux/Cart";
import { useDispatch, useSelector } from "react-redux";
import { SET_USER_SELECTED_METHOD } from "../../Redux/Payment";
import { RootState } from "../../Redux/Store/Store";
import { STORAGE_CONSTANTS } from "../../shared/Constants/Constants";
import { useTranslation } from "react-i18next";
import DatePicker from "react-datepicker";
import Free from "../../assets/images/free.png";
import { getImageUrl } from "../../Utils/imageUtils";


const ConfirmOrder: React.FC = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const { t, i18n } = useTranslation();
  const styles = getStyles(isMobile);
  // const breadcrumbs: string[] = ["Home", "Cart"];

  const breadcrumbs: string[] = [t("footer.home"), t("cart.cart")];
  const [selectedMethod, setSelectedMethod] = useState<string>("");
  const [products, setProducts] = useState<any>('');
  const [deliveryNote, setDeliveryNote] = useState<any>('');
  const [amount, setAmount] = useState<any>("");
  const [payment, setPayment] = useState<any>("");
  const [uuid, setUuid] = useState<any>("");
  const [deliveryDate, setDeliveryDate] = useState<Date | null>(new Date());
  const [loading, setLoading] = useState<boolean>(false);
  const [estimatedCost, setEstimatedCost] = useState<number | null>(null);
  const [serviceable, setServiceable] = useState<boolean>(true);
  const userSelectedMethod = useSelector((state: any) => state.Payment.userSelectedMethod)
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const userAddress: any = useSelector(
    (state: RootState) => state.User.UserAddress
  );

  const handleMethodChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSelectedMethod(event.target.value);
  };

  const {
    first_name,
    last_name,
    address_str,
    city,
    pincode,
    email,
    mobile,
    state,
  } = userAddress;

  const Cart_Details = async () => {
    try {
      setLoading(true);
      const response = await View_Cart();
      // An empty cart comes back without cart_details
      if (response && response.status === 200 && response.data.cart_details) {
        setProducts(response.data.cart_details.order.order_list);
        setAmount(response.data.cart_details);
      } else {
        console.log("Error fetching Cart details");
      }
    } catch (error: any) {
      console.log("Error fetching Cart details", error);
    } finally {
      setLoading(false);
    }
  };

  const calculateEstimatedCost = async (productsList: any, destPincode: string) => {
    if (!productsList || Object.keys(productsList).length === 0) return;

    let totalCost: number | null = null;
    let isServiceable = true;

    for (const storeId of Object.keys(productsList)) {
      const storeItems = productsList[storeId];
      if (storeItems && storeItems.length > 0) {
        // Find origin pincode
        const originPincode = storeItems[0]?.product?.product_vendor_store?.pincode;

        // Calculate total weight for this store
        const totalWeight = storeItems.reduce((acc: number, item: any) => {
          const weight = parseFloat(item?.product?.weight) || 0;
          const qty = item?.quantity || 1;
          return acc + (weight * qty);
        }, 0);

        if (originPincode && destPincode) {
          try {
            const payload = {
              origin_pincode: String(originPincode),
              destination_pincode: String(destPincode),
              weight: totalWeight,
              delivery_scope: "on_demand"
            };
            const response = await Estimate_Cost(payload);
            if (response && response.status === 200 && response.data?.data) {
              const resData = response.data.data;
              if (resData.serviceable) {
                totalCost = (totalCost || 0) + (resData.estimated_cost || 0);
              } else {
                isServiceable = false;
                toast.error(`Delivery not serviceable for items from store ${storeId}`);
              }
            }
          } catch (error) {
            console.error("Error calculating estimated cost", error);
          }
        }
      }
    }

    setEstimatedCost(totalCost);
    setServiceable(isServiceable);
  };

  useEffect(() => {
    if (products && Object.keys(products).length > 0 && pincode) {
      calculateEstimatedCost(products, pincode);
    }
  }, [products, pincode]);

  const PaymentStatus = async () => {
    if (uuid) {
      try {
        const response = await Payment_Status(uuid);
        if (response && response.status === 200) {
          if (response.data.payment_status === false) {
            toast.error("Payment failed");
            localStorage.removeItem(STORAGE_CONSTANTS.UUID);
          }
        } else {
          console.log("Error fetching Payment status");
        }
      } catch (error: any) {
        console.log("Error fetching Payment status", error);
      }
    } else {
      console.log("submit order");
    }
  };

  useEffect(() => {
    // UserAddress is only set by the cart's "Next" and is cleared after an order or
    // a logo click, so coming back here (browser back, direct URL) leaves it empty
    if (!address_str) {
      // toastId dedupes it, as StrictMode runs this effect twice in development
      toast.info(t("responseMessage.selectAddress", "Please select an address to continue"), {
        toastId: "select-address",
      });
      navigate("/view-cart", { replace: true });
      return;
    }
    Cart_Details();
    setUuid(localStorage.getItem(STORAGE_CONSTANTS.UUID));
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (uuid) {
      PaymentStatus();
    }
  }, [uuid]);

  const handlePaymentCOD = async (id: any) => {
    if (!address_str) {
      toast.error(t("responseMessage.selectAddress", "Please select an address to continue"), {
        toastId: "select-address",
      });
      navigate("/view-cart");
      return;
    }
    if (selectedMethod && deliveryDate) {
      try {
        const payload = {
          currency: "NPR",
          // code: "OFF21",
          order_id: id,
          submit: true,
          first_name: first_name || "",
          last_name: last_name || "",
          email: email || "",
          mobile_number: mobile || "",
          address: address_str || "",
          city: city || "",
          pincode: parseInt(pincode) || "",
          country: "nepal",
          state: state || "",
          payment_gateway: selectedMethod,
          gateway_data: {},
          success_val: true,
          delivery_date: deliveryDate.toISOString(),
          order_note: deliveryNote ? deliveryNote : ""
        };

        const response = await COD_Payment(payload);

        if (response && response.status === 200) {
          setPayment(response?.data?.payment_url);
          localStorage.setItem(
            STORAGE_CONSTANTS.UUID,
            response?.data?.payment_url
          );

          dispatch(CLEAR_CART());
          if (selectedMethod === "cod") {
            dispatch(SET_USER_SELECTED_METHOD("cod"))
            navigate("/thank-you", {
              state: {
                estimatedCost,
              },
            });
            toast.success("Order placed successfully");
          }

          if (selectedMethod === "eSewa") {
            const url: any = response.data.payment_url + "&web=true";
            const paymentWindow = window.open(url, "_self");
          }
          else if (selectedMethod === "khalti") {
            const url: any = response.data.payment_url + "&web=true";
            const paymentWindow = window.open(url, "_self");


          } else {
            console.log("error");
          }
        } else {
          toast.error(response.data.message);
        }
      } catch (error) {
        toast.error("Failed to place order. Please try again.");
      }
    } else {
      toast.error("Please select a payment method to place your order");
    }
  };

  return (
    <>
      <Section className="viewCart">
        <Container>
          <Row>
            <Col>
              <div className="breadcrumbs">
                {breadcrumbs.map((crumb, index) => (
                  <React.Fragment key={index}>
                    <span
                      style={{
                        color: index === 0 ? "var(--primary-color)" : "#BEB8B8",
                        fontFamily: "var(--primary-font-medium)",
                        fontSize: 16,
                      }}
                    >
                      {crumb}
                    </span>
                    {index !== breadcrumbs.length - 1 && (
                      <FaArrowRight
                        className="mx-2"
                        style={{ color: "#BEB8B8" }}
                      />
                    )}
                  </React.Fragment>
                ))}
              </div>
            </Col>
          </Row>
          <Row className="py-4">
            <Heading text={t("cart.confirmOrder")} alignment="left" />
          </Row>
        </Container>
        <div style={styles.whiteWrap}>
          {loading && (
            <Row>
              <Col className="d-flex align-items-center justify-content-center">
                <Spinner animation="grow" variant="primary" role="status">
                  <span className="visually-hidden">Loading...</span>
                </Spinner>
              </Col>
            </Row>
          )}
          {!loading && (
            <Container className="below">
              <Row style={styles.cartFirst} className="cart-row">
                <Col
                  sm={7}
                  style={styles.cartLeftCol}
                  className="cart-col-left"
                >
                  <div style={styles.cartTitle}>
                    {/* <p className="mb-1"> {t("cart.getItBy")} </p> */}
                    <Form.Group controlId="deliveryDate">
                      <Form.Label>{t("cart.getItBy")}</Form.Label>&nbsp;&nbsp;
                      <DatePicker
                        selected={deliveryDate}
                        onChange={(date: Date) => setDeliveryDate(date)}
                        minDate={new Date()}
                        dateFormat="dd/MM/yyyy"
                        className="form-control"
                      />
                    </Form.Group>
                  </div>
                  <div style={styles.cartItem}>
                    {Object.values(products).map((item: any) =>
                      item.map((ele: any) => {
                        const isFreeProduct = ele?.is_free_product;
                        return (
                          <Row
                            className={`d-flex align-items-center cart-item-row ${isFreeProduct ? "free-product" : ""
                              }`}
                            style={styles.oneCart}
                          >
                            <Col sm={2} className="cartImageCol">
                              {ele?.is_free_product ? (
                                <div className="freeIcon">
                                  <Image
                                    src={Free}

                                  // style={styles.productImage}
                                  /></div>
                              ) : null}
                              <div style={styles.productImageWrap}>
                                <Image
                                  src={
                                    getImageUrl(ele?.product?.product_image) ||
                                    ProductImage
                                  }
                                  style={styles.productImage}
                                  onError={(e) => (e.currentTarget.src = DefaultProduct)} // Replace with default image

                                />
                              </div>
                            </Col>
                            <Col sm={4} className="cartProductInfoCol">

                              <div style={styles.productNameWt}>
                                <h3 style={styles.productName}>
                                  {ele?.product?.product_name}
                                </h3>
                                <h2 style={styles.productWt}>
                                  {ele?.product?.weight}{ele?.product?.unit_measure}
                                </h2>
                              </div>
                            </Col>
                            <Col sm={3} className="cartQuantityCol">
                              <div
                                className="add-to-cart"
                                style={{ borderRadius: 10 }}
                              >
                                <h2 style={styles.cartQty}>
                                  {" "}
                                  {t("userProfile.qty")} : {ele?.quantity}
                                </h2>
                              </div>
                            </Col>
                            <Col sm={3} className="cartPriceCol">
                              <div style={styles.productPrice}>
                                रु{ele?.price}
                              </div>
                            </Col>
                          </Row>
                        );
                      })
                    )}
                  </div>
                </Col>
                <Col
                  sm={5}
                  style={styles.cartRightCol}
                  className="cart-col-right"
                >
                  <h3 style={styles.cartTitle}>{t("cart.orderSummary")}</h3>
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <span style={styles.value500}>
                      {t("cart.subTotal")} ({amount?.cart_items} items)
                    </span>
                    <span style={styles.value600}>रु{amount?.f_total}</span>
                  </div>
                  {amount?.order?.order_details?.discount > 0 && (
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span style={styles.value500}>
                        {t("cart.itemSavings")}
                      </span>
                      <span style={{ ...styles.value600, color: "green" }}>
                        - रु{Math.floor(amount?.order?.order_details?.discount)}
                      </span>
                    </div>
                  )}
                  {estimatedCost !== null ? (
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span style={styles.value500}>Estimated Delivery Cost</span>
                      <span style={styles.value600}>रु{estimatedCost}</span>
                    </div>
                  ) : amount?.delivery_charge ? (
                    <div className="d-flex align-items-center justify-content-between mb-2">
                      <span style={styles.value500}>Delivery Partner Fee</span>
                      <span style={styles.value600}>रु{amount.delivery_charge}</span>
                    </div>
                  ) : null}

                  <hr />
                  <div className="d-flex align-items-center justify-content-between mb-2">
                    <span style={styles.value600}>{t("cart.orderTotal")}</span>
                    <span style={styles.value600}>
                      रु{estimatedCost !== null ? (amount?.total_amount - (amount?.delivery_charge || 0) + estimatedCost) : amount?.total_amount}
                    </span>
                  </div>

                  <div>
                    <h3 style={styles.cartTitle}>
                      {t("cart.deliveryAddress")}
                    </h3>
                  </div>
                  <div
                    style={styles.selectedAddressWrap}
                    className="py-4 selectedAddressWrap"
                  >
                    <div style={styles.selectedAddressText}>
                      <div style={styles.selectedAddressTitle}>
                        {first_name &&
                          last_name &&
                          `${first_name} ${last_name}`}
                      </div>
                      {address_str}
                      <br></br>
                      {`${city},${pincode}`}
                      <br></br>
                      {mobile}
                    </div>
                  </div>
                  <div className="mt-3">
                    <Form.Label style={styles.cartTitle}>
                      {t("viewOrder.deliveryNote")}
                    </Form.Label>
                    <div>
                      <textarea
                        className="form-control"
                        value={deliveryNote}
                        onChange={(e) => setDeliveryNote(e.target.value)}
                      />
                    </div>
                  </div>
                  <div style={styles.paymentMethodWrap} className="mt-3">
                    <Form className="paymentRadio">
                      <Form.Group as={Col} controlId="paymentMethod">
                        <Form.Label style={styles.cartTitle}>
                          {t("cart.selectPaymentMethod")}
                        </Form.Label>
                        <div key={`inline-radio`} className="mb-3">
                          <Form.Check
                            inline
                            label={"E-sewa"}
                            type="radio"
                            id={`inline-radio-1`}
                            value="eSewa"
                            checked={selectedMethod === "eSewa"}
                            onChange={handleMethodChange}
                          />
                          <Form.Check
                            inline
                            label={"Khalti"}
                            type="radio"
                            id={`inline-radio-3`}
                            value="khalti"
                            checked={selectedMethod === "khalti"}
                            onChange={handleMethodChange}
                          /> 
                          <Form.Check
                            inline
                            label={t("cart.cod")}
                            type="radio"
                            id={`inline-radio-2`}
                            value="cod"
                            checked={selectedMethod === "cod"}
                            onChange={handleMethodChange}
                          />
                        </div>
                      </Form.Group>
                    </Form>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col>
                  <div className="justify-content-center d-flex mt-3">
                    <Button
                      className="btnBlue"
                      style={{ minWidth: 250 }}
                      onClick={() => handlePaymentCOD(amount?.order?.id)}
                    >
                      {t("cart.placeOrder")}
                    </Button>
                  </div>
                </Col>
              </Row>
            </Container>
          )}
        </div>
      </Section>
    </>
  );
};

export default ConfirmOrder;
